import gql from 'graphql-tag';

import { Mutation, Query } from 'core';

const PROJECT_LIST_FIELDS = gql`
  fragment minimalProjectListFields on Project {
    id
    name
    private
    slug
  }
`;

const PROJECT_CONNECTION_FIELDS = gql`
  ${PROJECT_LIST_FIELDS}
  fragment minimalProjectConnectionFields on ProjectConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        ...minimalProjectListFields
      }
    }
  }
`;

const PROFILE_PROJECTS = gql`
  ${PROJECT_CONNECTION_FIELDS}
  query ProfileProjects(
    $username: String!
    $cursor: String
    $batchSize: Int
    $sortBy: String
  ) {
    profile(username: $username) {
      id
      projects(first: $batchSize, after: $cursor, sortBy: $sortBy) {
        ...minimalProjectConnectionFields
      }
    }
  }
`;

const MEMBERS_BY_PROJECTS = gql`
  query GroupsByProjects($spaceId: ID!, $projectIds: [ID!]!) {
    groupsByProjects(spaceId: $spaceId, projectIds: $projectIds) {
      id
      username
      __typename
    }
  }
`;

const INITIATIVE_QUERY = gql`
  query Initiative($slug: String) {
    initiative(slug: $slug) {
      id
      billingSubscriptions {
        id
        plan {
          name
          type
        }
      }
      creditCards {
        id
        isDefault
        brand
        country
        name
        expMonth
        expYear
        lastDigits
      }
      groups {
        name
        pendingInvites {
          profile {
            username
            email
          }
        }
        members {
          profile {
            username
            email
          }
        }
      }
    }
  }
`;

const PROFILE_QUERY = gql`
  query Profile($username: String) {
    id
    billingSubscriptions {
      id
      plan {
        name
        type
      }
    }
    creditCards {
      id
      isDefault
      brand
      country
      name
      expMonth
      expYear
      lastDigits
    }
  }
`;

export const SPACE_FRAGMENT = gql`
  fragment SpaceFields on Space {
    id
    spaceType
    subscriptionType
    content {
      id
      slug
      title
      canUpdate
      canDelete
      avatar {
        id
        path
        url
      }
    }
  }
`;

const UPDATE_SUBSCRIPTION_MUTATION = gql`
  ${SPACE_FRAGMENT}
  mutation UpdateSubscription($arguments: UpdateSubscriptionInput!) {
    updateSubscription(arguments: $arguments) {
      subscription {
        plan {
          id
          name
          product {
            id
            name
          }
        }
        space {
          ...SpaceFields
        }
      }
    }
  }
`;

export class MembersByProjects extends Query {
  static conf = {
    GQL: MEMBERS_BY_PROJECTS,
    varNames: ['spaceId', 'projectIds'],
    resultPath: 'groupsByProjects',
  };
}

export class ProfileTransferProjectsQuery extends Query {
  static conf = {
    GQL: PROFILE_PROJECTS,
    varNames: ['username', 'cursor', 'sortBy', 'batchSize'],
    resultPath: 'profile.projects',
  };
}
export class ProfileQuery extends Query {
  static conf = {
    GQL: PROFILE_QUERY,
    varNames: ['username'],
  };
}
export class InitiativeQuery extends Query {
  static conf = {
    GQL: INITIATIVE_QUERY,
    varNames: ['slug'],
  };
}

const CREATE_SUBSCRIPTION_MUTATION = gql`
  ${SPACE_FRAGMENT}
  mutation CreateSubscription($arguments: CreateSubscriptionInput!) {
    createSubscription(arguments: $arguments) {
      subscription {
        plan {
          id
          product {
            id
            name
          }
        }
        id
        space {
          ...SpaceFields
        }
      }
    }
  }
`;

export class UpdateSubscriptionMutation extends Mutation {
  static conf = {
    GQL: UPDATE_SUBSCRIPTION_MUTATION,
    inputName: 'arguments',
    resultPath: 'updateSubscription',
  };
}

export class CreateSubscriptionMutation extends Mutation {
  static conf = {
    GQL: CREATE_SUBSCRIPTION_MUTATION,
    inputName: 'arguments',
    resultPath: 'createSubscription',
  };
}
